import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes - data is considered fresh for 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes - cache time (formerly cacheTime)
      // retry: (failureCount, error: any) => {
      //   // For local storage operations, don't retry on errors
      //   // since they're usually permission/quota issues
      //   return false
      // },
      refetchOnWindowFocus: false, // Don't refetch on window focus for local storage
      refetchOnReconnect: false, // Don't refetch on reconnect for local storage
    },
    mutations: {
      retry: false, // Don't retry mutations for local storage
    },
  },
}) 